module.exports = __webpack_public_path__ + "img/yiCity.15457891.png";